exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-store-logos{display:flex;flex-wrap:wrap;justify-content:space-around}.app-store-logos__button{padding:10px}\n", ""]);

// exports
exports.locals = {
	"app-store-logos": "app-store-logos",
	"app-store-logos__button": "app-store-logos__button"
};